import { Box, Typography } from "@mui/material";
import { useEvents, useNamespace } from "@mb-pro-ui/utils";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import type { StreamStatus } from "../api/useCustomerEventStream";
import { formatEventTime } from "./format";

// Without it a quiet list and a dead connection look the same.
export default function ConnectionDot({
  status,
  lastSuccess,
}: {
  status: StreamStatus;
  lastSuccess: number | null;
}) {
  const intl = useIntl();
  const socket = useNamespace();
  const [, setTick] = useState(0);
  // Re-render on connection changes; the state itself is read from the socket.
  useEvents(["connect", "disconnect", "connect_error"], () => setTick((t) => t + 1));

  const connected = !!socket?.connected;
  const live = connected && status === "ok";
  const color = live ? "success.main" : connected || status === "loading" ? "warning.main" : "error.main";

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, px: 0.5 }}>
      <Box sx={{ width: 10, height: 10, borderRadius: "50%", bgcolor: color, border: "1px solid rgba(255,255,255,0.8)" }} />
      <Typography variant="caption" sx={{ lineHeight: 1.1 }}>
        {live ? (
          <FormattedMessage defaultMessage="Live" />
        ) : status === "loading" ? (
          <FormattedMessage defaultMessage="Loading" />
        ) : connected ? (
          <FormattedMessage defaultMessage="Error" />
        ) : (
          <FormattedMessage defaultMessage="Reconnecting" />
        )}
        {!live && lastSuccess && (
          <Box component="span" sx={{ display: "block", opacity: 0.85 }}>
            {formatEventTime(intl, new Date(lastSuccess).toISOString())}
          </Box>
        )}
      </Typography>
    </Box>
  );
}
